import React, { useState } from 'react';
import PropTypes from 'prop-types';
import {
  Button,
  Row,
  Col,
  Label,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
} from 'reactstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import Dropzone from '~/components/common/Dropzone';

const JSONFileSelectModal = ({
  isOpen,
  setIsOpen,
  setData,
}) => {
  const [file, setFile] = useState();

  const handleCancel = () => {
    setIsOpen(false);
  };

  const handleSubmit = () => {
    setData({
      attributes: file.json,
    });

    setIsOpen(false);
  };

  return (
    <Modal isOpen={isOpen} backdrop="static">
      <ModalHeader>Select File</ModalHeader>

      <ModalBody>
        <form>
          <Row form>
            <Col sm>
              <Label className="text-primary d-block">
                Upload file
              </Label>

              <Dropzone
                setFile={setFile}
                acceptFileTypes="application/json"
              />
            </Col>
          </Row>
        </form>
      </ModalBody>

      <ModalFooter>
        <Button outline color="tertiary" type="cancel" onClick={handleCancel}>
          Cancel
        </Button>

        <Button color="primary" onClick={handleSubmit} disabled={!file}>
          <FontAwesomeIcon icon="upload" />

          <span className="d-none d-md-inline ml-2">
            Begin Upload
          </span>
        </Button>
      </ModalFooter>
    </Modal>
  );
};

JSONFileSelectModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  setIsOpen: PropTypes.func.isRequired,
  setData: PropTypes.func.isRequired,
};

export default JSONFileSelectModal;
